import { Request } from 'effect';
export class ModelRequestError {
    originalError;
    _tag = 'Backpack/Requests/Model/ModelRequestError';
    constructor(originalError) {
        this.originalError = originalError;
    }
}
export class ModelNotFoundError {
    productId;
    articleId;
    _tag = 'Backpack/Requests/Model/ModelNotFoundError';
    constructor(productId, articleId) {
        this.productId = productId;
        this.articleId = articleId;
    }
}
export const GetModel = Request.tagged('Backpack/Requests/Model/GetModel');
export class AttachmentRequestError {
    originalError;
    _tag = 'Backpack/Requests/Attachment/AttachmentRequestError';
    constructor(originalError) {
        this.originalError = originalError;
    }
}
export const GetAttachments = Request.tagged('Backpack/Requests/Attachment/GetAttachments');
